import { HOST, registerModel } from '@/utils/base';

export default [
    // 进销存 询比价
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //询价列表
            {
                path: 'purchase/inquiry_list',
                component: () => import('@/routes/psi/purchase/inquiry_list'),
            },
            //新增询价记录
            {
                path: 'purchase/inquiry_add',
                component: () => import('@/routes/psi/purchase/inquiry_add'),
            },
            //编辑询价
            // {
            //     path: 'purchase/inquiry_edit',
            //     component: () => import('@/routes/psi/purchase/inquiry_edit'),
            // },
            //询价详情
            {
                path: 'purchase/inquiry_info',
                component: () => import('@/routes/psi/purchase/inquiry_info'),
            },
            //比价定案列表
            {
                path: 'purchase/compare_list',
                component: () => import('@/routes/psi/purchase/compare_list'),
            },
            //新增比价定案
            {
                path: 'purchase/compare_add',
                component: () => import('@/routes/psi/purchase/compare_add'),
            },
            //比价定案详情
            {
                path: 'purchase/compare_info',
                component: () => import('@/routes/psi/purchase/compare_info'),
            },

        ],
    },
    // 采购单 及审批
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //采购列表
            {
                path: 'purchase/list',
                component: () => import('@/routes/psi/purchase/list'),
            },
            //新增采购单
            {
                path: 'purchase/add',
                component: () => import('@/routes/psi/purchase/add'),
            },

            //采购单详细
            {
                path: 'purchase/info',
                component: () => import('@/routes/psi/purchase/info'),
            },

            // //编辑采购单
            // {
            //     path: 'purchase/edit',
            //     component: () => import('@/routes/psi/purchase/edit'),
            // },
        ],
    },
    // 采购入库单
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //新增分车船采购入库入口列表
            {
                path: 'purchase/ingodown_car_list',
                component: () => import('@/routes/psi/purchase/ingodown_car_list'),
            },
            //新增分车船采购入库单
            {
                path: 'purchase/ingodown_car_add',
                component: () => import('@/routes/psi/purchase/ingodown_car_add'),
            },
            //新增采购直接入库单入口列表
            {
                path: 'purchase/ingodown_direct_list',
                component: () => import('@/routes/psi/purchase/ingodown_direct_list'),
            },
            //新增采购直接入库单
            {
                path: 'purchase/ingodown_direct_add',
                component: () => import('@/routes/psi/purchase/ingodown_direct_add'),
            },
            //采购入库单列表/ 
            {
                path: 'purchase/ingodown_list',
                component: () => import('@/routes/psi/purchase/ingodown_list'),
            },
            //采购入库单详细
            {
                path: 'purchase/ingodown_info',
                component: () => import('@/routes/psi/purchase/ingodown_info'),
            },
        ],
    },
    // 库存管理
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //库存查询
            {
                path: 'warehouse/list',
                component: () => import('@/routes/psi/warehouse/list'),
            },
            //新增采购入库单
            {
                path: 'warehouse/check',
                component: () => import('@/routes/psi/warehouse/check'),
            },
            //采购入库单详细
            {
                path: 'warehouse/manage',
                component: () => import('@/routes/psi/warehouse/manage'),
            },
            {
                path: 'warehouse/search',
                component: () => import('@/routes/psi/warehouse/search'),
            },
        ],
    },
    // 销售单及审批
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //销售单列表
            {
                path: 'sales/list',
                component: () => import('@/routes/psi/sales/list'),
            },
            //新增销售单
            {
                path: 'sales/add',
                component: () => import('@/routes/psi/sales/add'),
            },

            //销售单详细
            {
                path: 'sales/info',
                component: () => import('@/routes/psi/sales/info'),
            },

        ],
    },
    // 销售提发货单
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //xinz销售提发货单入口列表
            {
                path: 'sales/send_list',
                component: () => import('@/routes/psi/sales/send_list'),
            },
            //新增销售提发货
            {
                path: 'sales/send_add',
                component: () => import('@/routes/psi/sales/send_add'),
            },
            //新增销售提发货
            {
                path: 'sales/send_info',
                component: () => import('@/routes/psi/sales/send_info'),
            },
        ],
    },
    // 销售出库
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //销售出库单列表
            {
                path: 'sales/outbound_list',
                component: () => import('@/routes/psi/sales/outbound_list'),
            },
            //销售出库单出库
            {
                path: 'sales/outbound_add',
                component: () => import('@/routes/psi/sales/outbound_add'),
            },
            //销售出库单列表
            {
                path: 'sales/outgodown_list',
                component: () => import('@/routes/psi/sales/outgodown_list'),
            },
            //销售出库单详细
            {
                path: 'sales/outgodown_info',
                component: () => import('@/routes/psi/sales/outgodown_info'),
            },
            //销售实收出库列表
            {
                path: 'sales/outbound_real_list',
                component: () => import('@/routes/psi/sales/outbound_real_list'),
            },
            //销售出库实收
            {
                path: 'sales/outbound_real_add',
                component: () => import('@/routes/psi/sales/outbound_real_add'),
            },
            //销售出库实收
            {
                path: 'sales/outbound_real_info',
                component: () => import('@/routes/psi/sales/outbound_real_info'),
            },
        ],
    },
    // 分车船提送货
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //分车船提送货列表
            {
                path: 'pruchase/send_list',
                component: () => import('@/routes/psi/purchase/send_list'),
            },
            //新增
            {
                path: 'purchase/send_add',
                component: () => import('@/routes/psi/purchase/send_add'),
            },

            //详细
            {
                path: 'purchase/send_info',
                component: () => import('@/routes/psi/purchase/send_info'),
            },

            //编辑
            // {
            //     path: 'purchase/send_edit',
            //     component: () => import('@/routes/psi/purchase/send_edit'),
            // },
        ],
    },
    // 分车船入库
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //分车船提送货列表
            {
                path: 'purchase/ingodown_car_list',
                component: () => import('@/routes/psi/purchase/ingodown_car_list'),
            },
            //新增
            {
                path: 'purchase/ingodown_car_add',
                component: () => import('@/routes/psi/purchase/ingodown_car_add'),
            }
        ],
    },
    // 采购直接入库
    {
        path: HOST + 'psi',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //采购直接入库列表
            {
                path: 'purchase/ingodown_direct_list',
                component: () => import('@/routes/psi/purchase/ingodown_direct_list'),
            },
            //新增
            {
                path: 'purchase/ingodown_car_add',
                component: () => import('@/routes/psi/purchase/ingodown_direct_add'),
            }
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/psi_router.js